import { ButtonShapeProp } from '../properties';
import { ButtonShapeType } from '../types';

export function getButtonShape(shape?: ButtonShapeType) {
  if (!shape) return '';

  return ButtonShapeProp[shape];
}
